// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__gHL1g","navbar__button":"Navbar_navbar__button__DvSaM","navbar__button__icon":"Navbar_navbar__button__icon__VtI3F"};